import { render, staticRenderFns } from "./input.pug?vue&type=template&id=14765ded&lang=pug&"
import script from "./input.js?vue&type=script&lang=js&"
export * from "./input.js?vue&type=script&lang=js&"
import style0 from "./input.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14765ded')) {
      api.createRecord('14765ded', component.options)
    } else {
      api.reload('14765ded', component.options)
    }
    module.hot.accept("./input.pug?vue&type=template&id=14765ded&lang=pug&", function () {
      api.rerender('14765ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/index.vue"
export default component.exports